import script from "./FileInputUpload.vue?vue&type=script&lang=ts&setup=true"
export * from "./FileInputUpload.vue?vue&type=script&lang=ts&setup=true"

import "./FileInputUpload.vue?vue&type=style&index=0&id=9e7c8170&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9e7c8170"]])

export default __exports__